import { MutationEffect } from '@helpers/MutationEffect';
import { usePasswordResetMutation } from '@features/redux/apis/auth';
import { useAlert } from '@hooks/useAlert';

export const ResetPasswordEffects = () => {
    const { setAlert } = useAlert();

    const [, mutationState] = usePasswordResetMutation({ fixedCacheKey: 'ResetUserPassword' });

    return (
        <MutationEffect
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            mutationState={mutationState}
            effects={{
                isError: () => {
                    setAlert('Unable to request password reset.', 'error');
                    mutationState.reset();
                },
                isSuccess: () => {
                    setAlert('Successfully requested password reset.', 'success');
                    mutationState.reset();
                },
            }}
        />
    );
};
